import(/* webpackMode: "eager" */ "/app/src/app/[locale]/company/layout.tsx");
